import React from 'react';

//import { Panel, PanelHeader, PanelHeaderButton, Div, Link } from '@vkontakte/vkui';
//import { Icon56MoneyCircleFillBlue } from '@vkontakte/icons';

// Routes
import { ROUTE_DATE_PICKER, ROUTE_RESULT, ROUTE_ARKANE_DECODE } from '../../app/router';

import DatePicker from '../ArkaneDate/DateContainer';
import Result from '../ArkaneResult/ResultContainer';
import DecodeContainer from '../ArkaneDecode/DecodeContainer';

class MainPanel extends React.Component {
	
    componentDidMount = () => {
    }
	
    componentDidUpdate = () => {
    }
	
	renderContent = () => {

		switch (this.props.routeName) {

			case ROUTE_DATE_PICKER:
				return (<DatePicker/>);

			case ROUTE_RESULT:
				return (<Result/>);

			case ROUTE_ARKANE_DECODE:
				return (<DecodeContainer/>);
	
			default:
				break;
		}

		return (<DatePicker/>);
	}

	render = () => {

        //console.log('props', this.props);
		
		let clsName = "desktop";
		if ( this.props.isMobileView ) {
			clsName = "mobile";
		}

		return (
			<main className={clsName}>
				{this.renderContent()}
			</main>
		);
	}

}

export default MainPanel;
